<template>
  <div id="dataAnalyse" data-layout-mode="horizontal">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
      topNav: ['nav-platform', 'nav-ability-framework', 'nav-ability-graph'],
      subNav: [
        'nav-platform-index',
        'nav-invalid-course',
        'nav-access-analyse',
        'nav-ability-framework-index',
        'nav-ability-graph-index',
      ],
    }
  },
  updated() {
    for (let i of this.topNav) {
      document.getElementById(i + '')?.classList.remove('active')
    }
    for (let i of this.subNav) {
      document.getElementById(i + '')?.classList.remove('active')
    }
    this.$nextTick(function () {
      // console.log(this.$route.meta.activeTop)
      // console.log(this.$route.meta.activeSub)
      document.getElementById(this.$route.meta.activeTop + '')?.classList.add('active')
      document.getElementById(this.$route.meta.activeSub + '')?.classList.add('active')
    })
  },
  mounted() {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('data-layout-mode', 'horizontal')
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    async getUserInfoApi() {
      await this.$store
        .dispatch('commom/getUserInfo')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$store.commit('commom/setUserInfo', res.data)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async getRoleApi() {
      await this.$store
        .dispatch('commom/getRole')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$store.commit('commom/setRoleList', res.data)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
  },
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
}
</style>
